import { INotification, getNotificationsByAuthId, updateNotification } from '@/services/notification-service';
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const notificationSliceInitialState: NotificationSliceDataType = {
  notificationsData: [],
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState: notificationSliceInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getNotificationsThunk.fulfilled, (state, action: PayloadAction<INotification[]>) => {
      state.notificationsData = action.payload;
    });
    builder.addCase(markNotifcationAsReadThunk.fulfilled, (state, action) => {
      if (!!action.payload) state.notificationsData = state.notificationsData.map((item) => (item._id === action.payload?._id ? action.payload : item));
    });
  },
});

export default notificationSlice.reducer;
export interface NotificationSliceDataType {
  notificationsData: INotification[];
}

export const getNotificationsThunk = createAsyncThunk('notification/getNotificationsThunk', async (data: { authId: string; allNotifications?: boolean }) => {
  const response = await getNotificationsByAuthId({ authId: data.authId }, data.allNotifications ? undefined : 10);
  return response.data.data || [];
});

export const markNotifcationAsReadThunk = createAsyncThunk('notification/markNotifcationAsReadThunk', async (data: { _id: string }) => {
  const response = await updateNotification({ _id: data._id }, { isRead: true });
  return response.data.data;
});
